import React from 'react'

import { Button } from '@mui/material'
import PropTypes from 'prop-types'

import { logger } from '../utils/logger'

const styles = {
  container: {
    display: 'flex',
    backgroundColor: 'rgba(255,255,255,0.3)',
    justifyContent: 'center',
    alignItems: 'center',
    flex: '1 1 auto',
    height: '100vh',
  },
  wrapper: {},
}

export default class ErrorBoundary extends React.Component {
  static propTypes = {
    children: PropTypes.any,
  }
  constructor(props) {
    super(props)
    this.state = { error: null }
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error })
    logger.error('ErrorBoundary:', error, errorInfo)
  }

  render() {
    if (this.state.error) {
      return (
        <div style={styles.container}>
          <div style={styles.wrapper}>
            <p>We&apos;re sorry — something&apos;s gone wrong.</p>
            <p>Please try refreshing the page.</p>
            <Button color="primary" onClick={() => window.location.reload()}>
              Reload
            </Button>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
